import { render } from "./SendToSearchConfirmation.vue?vue&type=template&id=2c000093&scoped=true"
import script from "./SendToSearchConfirmation.vue?vue&type=script&lang=js"
export * from "./SendToSearchConfirmation.vue?vue&type=script&lang=js"

import "./SendToSearchConfirmation.vue?vue&type=style&index=0&id=2c000093&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c000093"]])

export default __exports__